import {defineMessages} from 'react-intl';

const messages = defineMessages({
  goesOffline: {
    id: 'goesOffline',
    defaultMessage: "You're offline. Check your internet connection."
  },
  goesBackOnline: {
    id: 'goesBackOnline',
    defaultMessage: "You're back online!"
  }
});

export default messages;
